import { cn } from '@/lib/utils'

interface AuthFormHeaderProps {
  title?: string
  subtitle?: string
  className?: string
  titleClassName?: string
  subtitleClassName?: string
}

export const AuthFormHeader = ({
  title,
  subtitle,
  className = '',
  titleClassName = '',
  subtitleClassName = '',
}: AuthFormHeaderProps) => {
  if (!title && !subtitle) return null

  return (
    <div className={cn('flex flex-col items-center gap-2 text-center', className)}>
      {title && <h1 className={cn('text-2xl font-bold', titleClassName)}>{title}</h1>}
      {subtitle && <p className={cn('text-muted-foreground text-sm text-balance', subtitleClassName)}>{subtitle}</p>}
    </div>
  )
}
